import { defineModule } from 'direct-vuex'
import { moduleActionContext, moduleGetterContext } from '@/store'
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import { SliceType } from '@shared/types/database'
import { TextAreaChartType } from '@/components/Survey/Utilities/ChartUtilities'

export interface ChartInfo {
  chartRef : Chart & { chart: Highcharts.Chart }
  exporting : Highcharts.ExportingOptions,
  chartType: TextAreaChartType | undefined,
  sliceBy : SliceType,
  selectedTab : string,
  fileName: string
}

export interface LivechartRefState {
  // QuestionID: ChartReference
  chartReferenceMap: Record<string, ChartInfo>,
  chartsLoaded: boolean
}

const createLivechartRefState = (): LivechartRefState => ({
  chartReferenceMap: {},
  chartsLoaded: false
})

const livechartRefs = defineModule({
  namespaced: true,
  state: createLivechartRefState,
  mutations: {
    resetRefMap (state) {
      state.chartReferenceMap = {}
    },
    addReferenceToMap (state, payload: { questionId: string, chartInfo: ChartInfo }) {
      const { questionId, chartInfo } = payload
      state.chartReferenceMap[questionId] = chartInfo
    },
    setLoaded (state, loaded: boolean) {
      state.chartsLoaded = loaded
    }
  },
  getters: {
    chartRefMap (state: LivechartRefState) {
      return state.chartReferenceMap
    }
  },
  actions: {
    addRefToMap (context, payload: { questionId: string, chartInfo: ChartInfo }) {
      const { commit, state } = livechartRefsActionContext(context)
      if (!state.chartsLoaded) {
        commit.setLoaded(true)
      }
      commit.addReferenceToMap(payload)
    },
    resetRefMap (context) {
      const { commit } = livechartRefsActionContext(context)
      commit.setLoaded(false)
      commit.resetRefMap()
    }
  }
})

export default livechartRefs
export const livechartRefsGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, livechartRefs)
export const livechartRefsActionContext = (context:any) => moduleActionContext(context, livechartRefs)
